<template>
  <div id="login_form">
    <div class="error_message">{{ errorMessage.text }}</div>
    <div id="login_input">
      <div id="login_id">
        <div class="bold">ログインID（メールアドレス）</div>
        <div>
          <input
              type="text"
              v-model="form.loginId"
              placeholder="メールアドレスを入力してください"
          />
        </div>
        <div class="error_message">{{ fieldErrorMessages.loginId }}</div>
      </div>
      <div id="login_pass">
        <div class="bold">パスワード</div>
        <div>
          <input
            type="password"
            v-model="form.password"
            placeholder="パスワードを入力してください"
          />
        </div>
        <div class="error_message">{{ fieldErrorMessages.password }}</div>
      </div>
      <router-link to="/mmstyle/user/reset/input">パスワードをお忘れの方はこちら</router-link>
    </div>
    <div id="login_btn">
      <div><button class="detail_btn" @click="login()"><i class='bx bx-log-in bx-sm'></i> ログイン</button></div>
    </div>
    <p v-show="isOrderSignIn">
      ※ ログイン後カート画面へ戻りますので、改めて「注文へ進む」より決済を完了ください。
    </p>
  </div>
</template>
<script>
import axios from 'axios'
import {DC_URL, DC_STORAGE_KEY} from '../../../constants/App'
import * as Api from '../../../utils/Api'
import * as App from '../../../utils/App'

export default {
  name: 'Login',
  components: {
  },
  props: {
    routeType: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      form: {
        loginId: '',
        password: ''
      },
      categoryList: [],
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        loginId: '',
        password: ''
      }
    }
  },
  computed: {
    isOrderSignIn: function () {
      if (this.routeType === 1) {
        return true
      }
      return false
    }
  },
  methods: {
    login: function (event) {
      // 旧データ削除
      App.removeLocalStorage(DC_STORAGE_KEY.TOP_FORM)
      App.removeLocalStorage(DC_STORAGE_KEY.PRICE_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
      App.removeLocalStorage(DC_STORAGE_KEY.SAVE_PLAN)
      App.removeLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
      App.removeLocalStorage(DC_STORAGE_KEY.SELECT_PLAN)
      App.removeLocalStorage(DC_STORAGE_KEY.PAYMENT_TYPE)
      App.removeLocalStorage(DC_STORAGE_KEY.PRODUCT_SEARCH)

      App.removeLocalStorage(DC_STORAGE_KEY.PREF_RESEARCH)
      App.removeLocalStorage(DC_STORAGE_KEY.RESEARCH_CHECKED)
      App.removeLocalStorage(DC_STORAGE_KEY.RESEARCH_DATA)

      let payload = {
        loginId: this.form.loginId,
        password: this.form.password
      }
      this.clearMessages()
      axios.post(DC_URL.LOGIN, payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.errorMessage.text = response.data.errorMessage
          } else {
            // ログイン成功時ローカルストレージにユーザー情報を格納※セキュリティ上問題ないもののみ
            let data = response.data.data
            let userInfo = {
              userId: data.userId,
              corpId: data.corpId,
              corpName: data.corpName,
              userLastName: data.userLastName,
              userFirstName: data.userFirstName,
              userLastNameKana: data.userLastNameKana,
              userFirstNameKana: data.userFirstNameKana,
              email: data.email,
              userType: data.userType,
              postcd: data.postcd,
              state: data.state,
              city: data.city,
              street: data.street,
              tel: data.tel,
              userStatus: data.userStatus,
              userLevel: data.userLevel,
              paymentType: data.paymentType,
              isAccountPay: data.isAccountPay,
              menuServiceCode: data.menuServiceCode
            }
            // intercom
            let userFullName = data.userLastName + data.userFirstName
            window.intercomSettings = {
              app_id: 'APP_ID',
              name: userFullName,
              email: data.email,
              user_id: data.userId
            }
            App.setLocalStorage(DC_STORAGE_KEY.USER_INFO, userInfo)
            if (this.routeType === 1) {
              this.$router.push({
                name: 'Cart'
              })
            } else if (this.routeType === 2) {
              this.$router.push({
                name: 'DcSketchOrder'
              })
            } else if (userInfo.userStatus === 'REGISTERED') {
              this.$router.push('/mmstyle/top')
            } else if (userInfo.userStatus === 'NEW') {
              this.$router.push('/mmstyle/password')
            }
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        })
    },
    getCategoryList: async function () {
      await axios.get(DC_URL.TOP + '/category')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          }
          this.categoryList = response.data.data
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    clearMessages: function () {
      this.errorMessage = { text: '' }
      this.fieldErrorMessages = {
        loginId: '',
        password: ''
      }
    }
  }
}
</script>
<style src="../../css/dc-login.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/login/DcLoginForm.vue